// Module configuration for generic DataModule pages
import React from "react";
import { fmtDate } from "../lib/api";
import { QUALIFICHE, RUOLI_OP } from "./operatore";

const CONTRATTO_LABEL = { determinato: "Determinato", indeterminato: "Indeterminato", stagista: "Stagista", cooperativa: "Cooperativa" };
const senzaScadenza = (c) => { const n = (c || "").toLowerCase(); return n.includes("indetermin"); };
const contrattoLabel = (c) => { if (!c) return "—"; if (CONTRATTO_LABEL[c]) return CONTRATTO_LABEL[c]; const n = c.toLowerCase(); if (n.includes("indetermin")) return "Indeterminato"; if (n.includes("determin")) return "Determinato"; if (n.includes("cooperativ")) return "Cooperativa"; if (n.includes("stagist") || n.includes("tirocin")) return "Stagista"; return c; };
const giorniScadenza = (r) => {
  if (senzaScadenza(r.contratto) || !r.scadenza_contratto) return null;
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const d = new Date(r.scadenza_contratto); d.setHours(0, 0, 0, 0);
  return Math.round((d - t) / 86400000);
};
const giorniLabel = (r) => { const g = giorniScadenza(r); if (g === null) return "—"; return g < 0 ? `Scaduto da ${Math.abs(g)}g` : (g === 0 ? "Scade oggi" : `${g} giorni`); };
const normContratto = (c) => { const n = (c || "").toLowerCase(); if (!n) return ""; if (n.includes("indetermin")) return "indeterminato"; if (n.includes("determin")) return "determinato"; if (n.includes("cooperativ")) return "cooperativa"; if (n.includes("stagist") || n.includes("tirocin")) return "stagista"; return n; };

export const MODULES = {
  ospiti: {
    title: "Ospiti", section: "ospiti", newLabel: "Nuovo ospite", detailBase: "/ospiti", rosterRette: true, bulkPay: true, structByMonth: true,
    columns: [
      { key: "cognome", label: "Cognome" },
      { key: "nome", label: "Nome" },
      { key: "structure_id", label: "Struttura", struct: true },
      { key: "autonomia", label: "Autonomia", badge: "autonomia" },
      { key: "retta_prevista", label: "Retta prevista", editNum: true, perm: "rette" },
      { key: "incassato", label: "Incassato", editNum: true, perm: "rette" },
      { key: "stato_doc", label: "Stato", docStato: true },
      { key: "blocco_posto", label: "B.P.", bloccoPosto: true, perm: "blocco_posto" },
      { key: "registro", label: "Reg", registroToggle: true, perm: "registro" },
    ],
    fields: [
      { key: "struttura", label: "Struttura", type: "struttura", req: true },
      { key: "nome", label: "Nome", req: true },
      { key: "cognome", label: "Cognome" },
      { key: "sesso", label: "Sesso", type: "select", options: ["M", "F"] },
      { key: "data_nascita", label: "Data di nascita", type: "date" },
      { key: "codice_fiscale", label: "Codice fiscale" },
      { key: "camera", label: "Camera" },
      { key: "posto_letto", label: "Posto letto" },
      { key: "retta_mensile", label: "Retta mensile (€)", type: "number", perm: "rette", createOnly: true },
      { key: "data_ingresso", label: "Data ingresso", type: "date" },
      { key: "autonomia", label: "Autonomia", type: "select", options: [["verde", "Autosufficiente"], ["arancione", "Parz. autosufficiente"], ["rosso", "Segnalato ADI"]] },
      { key: "presenza", label: "Stato", type: "select", options: [["presente", "Presente"], ["ospedale", "Ricoverato"], ["uscita", "Uscito"], ["dimesso", "Dimesso"]] },
      { key: "medico_base", label: "Medico di base" },
      { key: "telefono_medico", label: "Telefono medico" },
      { key: "responsabile_id", label: "Operatore responsabile", type: "operatore_responsabile" },
      { key: "familiare_referente", label: "Familiare referente" },
      { key: "telefono_familiare", label: "Telefono familiare" },
      { key: "email", label: "Email" },
      { key: "firmatario_tipo", label: "Firmatario convenzione", type: "select", options: [["ospite", "Ospite autonomo"], ["familiare", "Familiare / Parente"], ["amministratore", "Amministratore di sostegno"]] },
      { key: "rischio_alvo", label: "Rischio alvo", type: "select", options: ["basso", "medio", "alto"] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  operatori: {
    title: "Operatori", section: "operatori", newLabel: "Check-in operatore", newNavigate: "/check-in-operatore", detailBase: "/operatori",
    listFilters: [
      { key: "struttura", type: "struttura", match: (r, v) => v === "all" || ((r.structure_ids && r.structure_ids.length ? r.structure_ids : (r.structure_id ? [r.structure_id] : [])).includes(v)) },
      { key: "contratto", type: "select", options: [["all", "Tutti i contratti"], ["determinato", "Determinato"], ["indeterminato", "Indeterminato"], ["stagista", "Stagista"], ["cooperativa", "Cooperativa"]], match: (r, v) => v === "all" || normContratto(r.contratto) === v },
      { key: "scad30", type: "toggle", label: "In scadenza ≤ 30 giorni", match: (r, on) => { if (!on) return true; const g = giorniScadenza(r); return g !== null && g <= 30; } },
    ],
    columns: [
      { key: "cognome", label: "Cognome" }, { key: "nome", label: "Nome" },
      { key: "structure_ids", label: "Strutture", structs: true },
      { key: "qualifica", label: "Qualifica", badge: "qualifica" },
      { key: "ruolo", label: "Ruolo", compute: (r) => r.ruolo || "—" },
      { key: "contratto", label: "Contratto", compute: (r) => contrattoLabel(r.contratto) },
      { key: "contratto_inizio", label: "Inizio", compute: (r) => r.contratto_inizio || r.data_assunzione || "", date: true },
      { key: "scadenza_contratto", label: "Scadenza", compute: (r) => senzaScadenza(r.contratto) ? "—" : (r.scadenza_contratto ? fmtDate(r.scadenza_contratto) : "—") },
      { key: "giorni_scadenza", label: "Giorni alla scadenza", compute: (r) => giorniLabel(r),
        render: (r) => { const g = giorniScadenza(r); if (g === null) return "—"; const color = g < 0 ? "#dc2626" : g <= 30 ? "#d97706" : "#15803d"; return <span style={{ color, fontWeight: 700 }}>{giorniLabel(r)}</span>; } },
      { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "strutture", label: "Strutture (una, più o tutte)", type: "strutture", req: true },
      { key: "nome", label: "Nome", req: true }, { key: "cognome", label: "Cognome", req: true },
      { key: "qualifica", label: "Qualifica (mansione)", type: "select", options: QUALIFICHE },
      { key: "ruolo", label: "Ruolo (livello)", type: "select", options: RUOLI_OP },
      { key: "sesso", label: "Sesso", type: "select", options: ["M", "F"] },
      { key: "data_nascita", label: "Data di nascita", type: "date" },
      { key: "luogo_nascita", label: "Luogo di nascita" },
      { key: "codice_fiscale", label: "Codice fiscale" },
      { key: "indirizzo", label: "Indirizzo di residenza" },
      { key: "n_documento", label: "N° carta d'identità" },
      { key: "telefono", label: "Telefono" }, { key: "email", label: "Email" },
      { key: "pin", label: "PIN Firma Rapida (2 cifre)", placeholder: "es. 42" },
      { key: "data_assunzione", label: "Data assunzione", type: "date" },
      { key: "contratto", label: "Tipo contratto", type: "select", options: [["determinato", "Determinato"], ["indeterminato", "Indeterminato"], ["stagista", "Stagista"], ["cooperativa", "Cooperativa"]] },
      { key: "ore_mensili", label: "Ore mensili da contratto", type: "number" },
      { key: "contratto_inizio", label: "Inizio contratto", type: "date" },
      { key: "scadenza_contratto", label: "Scadenza contratto (Determinato/Stagista/Cooperativa)", type: "date" },
      { key: "stato", label: "Stato", type: "select", options: ["attivo", "assente", "sospeso", "cessato"] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  terapie: {
    title: "Terapie", section: "terapie", newLabel: "Nuova terapia",
    columns: [
      { key: "ospite_nome", label: "Ospite" }, { key: "farmaco", label: "Farmaco" },
      { key: "dosaggio", label: "Dosaggio" }, { key: "orari", label: "Orari" },
      { key: "tipo", label: "Tipo", badge: "tipo" }, { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "ospite", label: "Ospite", type: "ospite", req: true },
      { key: "farmaco", label: "Farmaco", req: true }, { key: "principio", label: "Principio attivo" },
      { key: "dosaggio", label: "Dosaggio" }, { key: "via", label: "Via somministrazione" },
      { key: "frequenza", label: "Frequenza" }, { key: "orari", label: "Orari" },
      { key: "data_inizio", label: "Data inizio", type: "date" }, { key: "data_fine", label: "Data fine", type: "date" },
      { key: "medico", label: "Medico prescrittore" },
      { key: "tipo", label: "Tipo", type: "select", options: [["ordinaria", "Ordinaria"], ["bisogno", "Al bisogno"]] },
      { key: "stato", label: "Stato", type: "select", options: ["attiva", "sospesa", "conclusa"] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  ospedale: {
    title: "Ospedale", section: "ospedale", newLabel: "Nuovo evento",
    monthly: { monthDate: "data" },
    columns: [
      { key: "ospite_nome", label: "Ospite" }, { key: "tipologia", label: "Tipologia" },
      { key: "ospedale", label: "Struttura" }, { key: "data", label: "Data", date: true },
      { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "ospite", label: "Ospite", type: "ospite", req: true },
      { key: "tipologia", label: "Tipologia", type: "select", options: ["ricovero", "pronto soccorso", "visita programmata", "esame diagnostico"] },
      { key: "ospedale", label: "Ospedale / struttura" }, { key: "reparto", label: "Reparto" },
      { key: "motivo", label: "Motivo" }, { key: "data", label: "Data uscita", type: "date" },
      { key: "accompagnatore", label: "Accompagnatore" }, { key: "data_rientro", label: "Data prevista rientro", type: "date" },
      { key: "stato", label: "Stato", type: "select", options: [["ricoverato", "Ricoverato"], ["programmato", "Programmato"], ["rientrato", "Rientrato"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  uscite: {
    title: "Uscite", section: "uscite", newLabel: "Registra uscita",
    monthly: { monthDate: "data" },
    columns: [
      { key: "ospite_nome", label: "Ospite" }, { key: "tipo", label: "Tipo" },
      { key: "data", label: "Data", date: true }, { key: "ora", label: "Ora" },
      { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "ospite", label: "Ospite", type: "ospite", req: true },
      { key: "tipo", label: "Tipo uscita", type: "select", options: ["uscita con parenti", "pranzo o cena", "passeggiata", "evento", "vacanza", "commissione", "altro"] },
      { key: "motivo", label: "Motivo" }, { key: "luogo", label: "Luogo" },
      { key: "data", label: "Data uscita", type: "date", req: true }, { key: "ora", label: "Ora uscita", req: true },
      { key: "data_rientro", label: "Rientro previsto", type: "date" },
      { key: "accompagnatore", label: "Accompagnatore" }, { key: "telefono", label: "Telefono" },
      { key: "stato", label: "Stato", type: "select", options: [["programmato", "Programmato"], ["in corso", "In corso"], ["rientrato", "Rientrato"], ["annullato", "Annullato"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  visite: {
    title: "Visite", section: "visite", newLabel: "Nuova visita",
    monthly: { monthDate: "data" },
    columns: [
      { key: "ospite_nome", label: "Ospite" }, { key: "tipologia", label: "Tipologia" },
      { key: "visitatore", label: "Visitatore" }, { key: "data", label: "Data", date: true },
      { key: "ora_inizio", label: "Ora" }, { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "ospite", label: "Ospite", type: "ospite" },
      { key: "tipologia", label: "Tipologia", type: "select", options: ["familiare", "ASL", "medica", "fisioterapista", "assistente sociale", "tecnico", "controllo istituzionale", "altra"] },
      { key: "visitatore", label: "Nominativo visitatore" }, { key: "relazione", label: "Ente / relazione" },
      { key: "telefono", label: "Telefono" }, { key: "data", label: "Data", type: "date", req: true },
      { key: "ora_inizio", label: "Ora inizio", req: true }, { key: "ora_fine", label: "Ora fine" },
      { key: "referente", label: "Referente interno" },
      { key: "stato", label: "Stato", type: "select", options: [["programmato", "Programmato"], ["confermato", "Confermato"], ["completato", "Completato"], ["annullato", "Annullato"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  pulizie: {
    title: "Pulizie", section: "pulizie", newLabel: "Nuova attività",
    columns: [
      { key: "area", label: "Area" }, { key: "descrizione", label: "Descrizione" },
      { key: "frequenza", label: "Frequenza" }, { key: "operatore", label: "Operatore" },
      { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "area", label: "Area", type: "select", options: ["Camere", "Bagni", "Corridoi", "Cucina", "Lavanderia", "Soggiorno", "Sala da pranzo", "Infermeria", "Uffici", "Spazi esterni"] },
      { key: "elemento", label: "Elemento" }, { key: "descrizione", label: "Descrizione" },
      { key: "frequenza", label: "Frequenza", type: "select", options: ["a ogni turno", "giornaliera", "settimanale", "mensile", "trimestrale", "annuale"] },
      { key: "operatore", label: "Operatore assegnato" }, { key: "data", label: "Data prevista", type: "date" },
      { key: "stato", label: "Stato", type: "select", options: [["da_fare", "Da fare"], ["in_corso", "In corso"], ["completata", "Completata"], ["non_completata", "Non completata"], ["rinviata", "Rinviata"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  rette: {
    title: "Ricavi e Rette", section: "rette", newLabel: "Nuova retta",
    columns: [
      { key: "ospite_nome", label: "Ospite" }, { key: "importo", label: "Retta mensile", eur: true },
      { key: "metodo", label: "Metodo" }, { key: "giorno_pagamento", label: "Giorno pagamento" },
    ],
    fields: [
      { key: "ospite", label: "Ospite", type: "ospite", req: true },
      { key: "importo", label: "Importo mensile (€)", type: "number" },
      { key: "servizi", label: "Servizi aggiuntivi (€)", type: "number" },
      { key: "sconti", label: "Sconti (€)", type: "number" },
      { key: "giorno_pagamento", label: "Giorno pagamento" },
      { key: "intestatario", label: "Intestatario" },
      { key: "metodo", label: "Metodo", type: "select", options: ["bonifico", "contanti", "assegno", "RID"] },
      { key: "data_inizio", label: "Data inizio", type: "date" },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  spese: {
    title: "Varie", section: "spese", newLabel: "Nuova voce",
    monthly: { monthDate: "data_documento", amount: "totale", f24Field: "iva_ritenuta" },
    columns: [
      { key: "structure_id", label: "Struttura", struct: true },
      { key: "categoria", label: "Categoria" }, { key: "fornitore", label: "Fornitore" },
      { key: "data_documento", label: "Data", date: true }, { key: "totale", label: "Totale", eur: true },
      { key: "iva_ritenuta", label: "IVA/Rit. F24", eur: true },
      { key: "totale_f24", label: "Totale con F24", eur: true, compute: (r) => Number(r.totale || 0) + Number(r.iva_ritenuta || 0) },
      { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "struttura", label: "Struttura", type: "struttura_split", req: true },
      { key: "categoria", label: "Categoria", type: "select", options: ["vitto", "pulizie", "manutenzione", "materiale sanitario", "farmaci", "arredi", "consulenze", "assicurazioni", "cancelleria", "trasporti", "formazione", "imposte", "affitto", "altre"] },
      { key: "fornitore", label: "Fornitore", type: "fornitore" }, { key: "descrizione", label: "Descrizione" },
      { key: "data_documento", label: "Data documento", type: "date" }, { key: "data_pagamento", label: "Data pagamento", type: "date" },
      { key: "imponibile", label: "Imponibile (€)", type: "number" }, { key: "iva", label: "IVA (€)", type: "number" },
      { key: "iva_ritenuta", label: "IVA / Ritenuta d'acconto da versare con F24 (€)", type: "number" },
      { key: "totale", label: "Totale (€)", type: "number" }, { key: "numero_fattura", label: "N. fattura" },
      { key: "stato", label: "Stato", type: "select", options: [["pagato", "Pagato"], ["non pagato", "Non pagato"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  utenze: {
    title: "Utenze", section: "utenze", newLabel: "Nuova utenza",
    monthly: { monthDate: "data_scadenza", amount: "importo" },
    columns: [
      { key: "structure_id", label: "Struttura", struct: true },
      { key: "tipo", label: "Tipo" }, { key: "fornitore", label: "Fornitore" },
      { key: "importo", label: "Importo", eur: true }, { key: "data_scadenza", label: "Scadenza", date: true },
      { key: "stato", label: "Stato", badge: "stato" },
    ],
    fields: [
      { key: "tipo", label: "Tipo", type: "select", options: ["energia", "gas", "acqua", "telefono", "internet", "rifiuti", "altre"] },
      { key: "fornitore", label: "Fornitore", type: "fornitore" }, { key: "numero_contratto", label: "N. contratto" },
      { key: "periodo", label: "Periodo competenza" }, { key: "data_bolletta", label: "Data bolletta", type: "date" },
      { key: "data_scadenza", label: "Scadenza", type: "date" }, { key: "importo", label: "Importo (€)", type: "number" },
      { key: "consumo", label: "Consumo", type: "number" }, { key: "unita", label: "Unità di misura" },
      { key: "stato", label: "Stato", type: "select", options: [["pagata", "Pagata"], ["non pagata", "Non pagata"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  fornitori: {
    title: "Fornitori", section: "spese", newLabel: "Nuovo fornitore", companyLevel: true,
    columns: [
      { key: "nome", label: "Fornitore" },
      { key: "categoria", label: "Categoria" },
      { key: "telefono", label: "Telefono" },
      { key: "email", label: "Email" },
      { key: "piva", label: "P.IVA" },
    ],
    fields: [
      { key: "nome", label: "Nome fornitore", req: true },
      { key: "categoria", label: "Categoria di spesa", type: "select", options: ["vitto", "pulizie", "manutenzione", "materiale sanitario", "farmaci", "arredi", "consulenze", "assicurazioni", "cancelleria", "trasporti", "formazione", "imposte", "affitto", "utenze", "altre"] },
      { key: "piva", label: "Partita IVA" }, { key: "codice_fiscale", label: "Codice Fiscale" },
      { key: "referente", label: "Referente" }, { key: "telefono", label: "Telefono" },
      { key: "email", label: "Email" }, { key: "iban", label: "IBAN" },
      { key: "indirizzo", label: "Indirizzo" },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  buste_paga: {
    title: "Buste Paga", section: "buste_paga", newLabel: "Nuova busta paga",
    monthly: { monthKey: "mese", amount: "totale_costo" },
    columns: [
      { key: "operatore_nome", label: "Operatore" }, { key: "mese", label: "Mese" },
      { key: "netto", label: "Netto", editNum: true },
      { key: "totale_costo", label: "Costo aziendale", editNum: true },
      { key: "stato", label: "Stato", statusToggle: true, statusOptions: ["non pagata", "pagata"] },
    ],
    fields: [
      { key: "operatore_nome", label: "Operatore", req: true }, { key: "mese", label: "Mese (AAAA-MM)" },
      { key: "lordo", label: "Lordo (€)", type: "number" }, { key: "netto", label: "Netto (€)", type: "number" },
      { key: "contributi", label: "Contributi (€)", type: "number" }, { key: "tfr", label: "TFR (€)", type: "number" },
      { key: "straordinari", label: "Straordinari (€)", type: "number" }, { key: "totale_costo", label: "Totale costo aziendale (€)", type: "number" },
      { key: "stato", label: "Stato", type: "select", options: [["pagata", "Pagata"], ["non pagata", "Non pagata"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
  pagamenti: {
    title: "Ricavi e Rette", section: "rette", newLabel: "Registra pagamento", bulkPay: true, showDischargeBadge: true, sortKey: "_cognome",
    monthly: { monthKey: "mese", amount: "importo_incassato" },
    columns: [
      { key: "ospite_nome", label: "Ospite", dischargeName: true }, { key: "mese", label: "Mese" },
      { key: "retta_prevista", label: "Retta prevista", editNum: true },
      { key: "importo_incassato", label: "Incassato", editNum: true },
      { key: "differenza", label: "Differenza", eur: true },
      { key: "stato", label: "Stato", statusToggle: true, statusOptions: ["da incassare", "parziale", "pagato"] },
      { key: "blocco_posto", label: "B.P.", bloccoPosto: true, perm: "blocco_posto" },
      { key: "registro", label: "Reg", registroToggle: true, perm: "registro" },
    ],
    fields: [
      { key: "ospite", label: "Ospite", type: "ospite", req: true },
      { key: "mese", label: "Mese (AAAA-MM)", req: true },
      { key: "retta_prevista", label: "Retta prevista (€)", type: "number" },
      { key: "importo_incassato", label: "Importo incassato (€)", type: "number" },
      { key: "differenza", label: "Differenza (€)", type: "number" },
      { key: "data_incasso", label: "Data incasso", type: "date" },
      { key: "stato", label: "Stato", type: "select", options: [["da incassare", "Da incassare"], ["parziale", "Parziale"], ["pagato", "Pagato"]] },
      { key: "note", label: "Note", type: "textarea" },
    ],
  },
};
